export default function AboutMethodImage() {
    // Used in AboutMethod to display main content illustration

    // BUILD
    return (
        <div className={`h-[224px] min-h-[224px] min-w-[224px] flex justify-center items-center`}>
            <img className={"object-contain h-full"}
                 src={'/images/aboutScreen/AboutFoxScientistIllustration.png'}
                 alt="Scientifique" />
        </div>
    );
}